import { Directive } from 'vue';

export function decimalFormatter(el: HTMLElement, { value }: { value: number }) {
   const input = el.querySelector('input');
   const min = value;

   if (!input || input.value === '') return;

   const inputValue = parseFloat(input.value);

   if (inputValue < min) {
      input.value = min.toString();
   }
}

const minValueDirective: Directive = {
   mounted: decimalFormatter,
   updated: decimalFormatter,
};

export default minValueDirective;
